(function() { window.GUID_1e2a9baf_e37d_45e3_ba0b_e04fda173b0c = { getGuid: function() { return "1e2a9baf-e37d-45e3-ba0b-e04fda173b0c"; } }; })();
function getAge(dateString, referenceDate) {
    var today = referenceDate;
    if (today == null) {
        today = new Date();
    }
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    if (today.getMonth() < birthDate.getMonth() || (today.getMonth() == birthDate.getMonth() && today.getDay() <= birthDate.getDay())) {
        age--;
    }
    return age;
}
function SelectElementContents(el) {
    requestAnimationFrame(function () {
        var range = document.createRange();
        range.selectNodeContents(el[0]);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    });
}
let clickCount = 0;
function ManageClickCount(e, callback) {
    var mouseButton = "";
    switch (e.which) {
        case 1:
            mouseButton = "left";
            break;
        case 2:
            mouseButton = "middle";
            break;
        case 3:
            mouseButton = "right";
            break;
        default:
            mouseButton = "left";
            break;
    }
    if (clickCount == 0) {
        setTimeout(function () {
            callback.call(this, mouseButton, clickCount);
            clickCount = 0;
        }, 350);
    }
    clickCount += 1;
}
function IsDefined(value) {
    return value !== "undefined";
}
function IsEven(n) {
    return IsNumber(n) && (n % 2 == 0);
}
function IsNumber(n) {
    return n == parseFloat(n);
}

//# sourceMappingURL=cs.lib.js.map
